"use client";

import { downloadFile } from "@/action/upload_excel_file";
import { useState } from "react";
import { FaFileDownload } from "react-icons/fa";

export default function FileDownload({ isClient }: { isClient?: boolean }) {
  const [loading, setLoading] = useState(false);

  const action = async () => {
    setLoading(true);

    const result = await downloadFile(); // call server action

    // Convert base64 back into a downloadable file
    const link = document.createElement("a");
    link.href = `data:${result.mimetype};base64,${result.buffer}`;
    link.download = result.filename;
    link.click();

    setLoading(false);
  };
  return (
    <form action={action}>
      <button type="submit" disabled={loading}>
        {loading ? (
          <div className="flex flex-col justify-center gap-2">
            <span>Entrain de chager</span>
            <span className="animate-spin rounded-full h-5 w-5 border-b-3 border-green-main " />
          </div>
        ) : (
          <div
            className={`flex flex-col gap-1 items-center cursor-pointer group ${isClient ? "text-white" : "text-[#111]"} `}
          >
            <FaFileDownload className="text-xl lg:text-3xl transition-all duration-300 group-hover:text-green-main cursor-pointer " />
            {isClient && (
              <span className="text-sm text-center transition group-hover:text-green-main  ">Fichier Excel</span>
            )}
          </div>
        )}
      </button>
    </form>
  );
}
